import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import {
  BOOLEAN,
  CHECKBOX,
  DATE,
  LOV,
  LOVCCENTRELIST,
  RADIO,
  RGROUP,
  RICH,
  RICHTEXT,
  SINGLE_REPEATING_FIELD,
  UMO_URL,
  VARCHAR,
  LINK,
} from './MetaTypes';
import TextInput from './TextInput';
import DateInput from './DateInput';
import SelectInput from './SelectInput';
import CheckboxInput from './CheckBoxInput';
import { ModalInput } from './ModalInput';
import RichTextInput from './RichTextInput';
import SingleRepeatInput from './SingleRepeatInput';
import RepeatingGroupInput from './RepeatingGroupInput';
import TextAreaInput from './TextAreaInput';

export const MetaInput = ({
  handleInputChange,
  metaType,
  fileIndex,
  tagIndex,
  metaTag,
  userInput,
  isRepeatingInputChild,
  isRGroupChild,
  intl,
}) => {
  let type;
  if (metaTag.meta.udefval === CHECKBOX) type = CHECKBOX;
  else if (metaTag.meta.udefval === RADIO) type = RADIO;
  else if (
    metaTag.extra.display_api === RICH ||
    metaTag.meta.udefval === RICH ||
    metaTag.meta.udefval === RICHTEXT
  )
    type = RICHTEXT;
  else type = metaTag.meta.type.toUpperCase();
  const isSingleRepeatingField =
    metaTag.meta.type.toUpperCase() == RGROUP
      ? false
      : metaTag.attributes.repeating_fields.toUpperCase() ===
        SINGLE_REPEATING_FIELD;

  const [showModal, setShowModal] = useState(false);
  if (isSingleRepeatingField && !isRepeatingInputChild && !isRGroupChild)
    return (
      <ModalInput
        component={
          <SingleRepeatInput
            fileIndex={fileIndex}
            tagIndex={tagIndex}
            handleInputChange={handleInputChange}
            id={'meta_' + metaTag.meta.id}
            isRGroup={false}
            isSingleRepeatingField={isSingleRepeatingField}
            metaTags={metaTag}
            parentUserInput={userInput}
            setShowModal={setShowModal}
            intl={intl}
          />
        }
        header={intl.formatMessage({ id: 'metaInput.addNewEntry' })}
        showModal={showModal}
        setShowModal={setShowModal}
        showFooter={false}
        intl={intl}
      />
    );
  switch (type) {
    case RGROUP:
      return (
        <ModalInput
          component={
            <RepeatingGroupInput
              fileIndex={fileIndex}
              tagIndex={tagIndex}
              handleInputChange={handleInputChange}
              id={'meta_' + metaTag.meta.id}
              metaTags={metaTag.rgroup.taglist}
              parentUserInput={userInput}
              setShowModal={setShowModal}
              intl={intl}
            />
          }
          header={
            intl.formatMessage({ id: 'metaInput.addNewEntry' }) +
            ' ' +
            metaTag.rgroup.name
          }
          showModal={showModal}
          setShowModal={setShowModal}
          showFooter={false}
          intl={intl}
        />
      );
      break;

    case VARCHAR:
    case UMO_URL:
    case LINK:
      return (
        <TextInput
          fileIndex={fileIndex}
          tagIndex={tagIndex}
          metaTag={metaTag}
          handleInputChange={handleInputChange}
          id={'meta_' + metaTag.meta.id}
          userInput={userInput}
          key={'meta_' + metaTag.meta.id}
        />
      );
      break;

    case RICHTEXT:
      return (
        <ModalInput
          component={
            <RichTextInput
              fileIndex={fileIndex}
              tagIndex={tagIndex}
              metaTag={metaTag}
              handleInputChange={handleInputChange}
              id={'meta_' + metaTag.meta.id}
              setShowModal={setShowModal}
              intl={intl}
            />
          }
          header={metaTag.meta.name}
          showModal={showModal}
          setShowModal={setShowModal}
          showFooter={false}
          intl={intl}
        />
      );
      break;

    case DATE:
      return (
        <DateInput
          fileIndex={fileIndex}
          tagIndex={tagIndex}
          metaTag={metaTag}
          handleInputChange={handleInputChange}
          id={'meta_' + metaTag.meta.id}
          userInput={userInput}
          intl={intl}
        />
      );
      break;

    case CHECKBOX:
      return (
        <CheckboxInput
          fileIndex={fileIndex}
          tagIndex={tagIndex}
          metaTag={metaTag}
          handleInputChange={handleInputChange}
          id={'meta_' + metaTag.meta.id}
          userInput={userInput}
          intl={intl}
        />
      );
      break;

    case LOVCCENTRELIST:
    case LOV:
    case BOOLEAN:
      return (
        <SelectInput
          fileIndex={fileIndex}
          tagIndex={tagIndex}
          metaTag={metaTag}
          handleInputChange={handleInputChange}
          isSearchable={false}
          id={'meta_' + metaTag.meta.id}
          userInput={userInput}
          intl={intl}
        />
      );
      break;

    default:
      return (
        <TextAreaInput
          fileIndex={fileIndex}
          tagIndex={tagIndex}
          metaTag={metaTag}
          handleInputChange={handleInputChange}
          id={'meta_' + metaTag.meta.id}
          userInput={userInput}
          intl={intl}
        />
      );
      break;
  }
};
